import { Block } from 'ui-kit/blocks'
import { Heading } from 'ui-kit/typography'
import { Picture } from 'ui-kit/picture'
import AIImage1x from './landing-ai@1x.avif'
import AIImage2x from './landing-ai@2x.avif'
import classes from './LandingAI.module.scss'

export const LandingAI = () => {
  return (
    <Block
      as={'section'}
      variant={'solidMob'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <Heading as={'h2'} size={'xl'} balance center className={classes.title}>
        Build any number of deep, highly customizable integrations using AI
      </Heading>
      <Picture
        src1x={AIImage1x.src}
        src2x={AIImage2x.src}
        deskBreakpoint={'992px'}
        alt='Build integrations using AI'
        width={1104}
        height={531}
        lazyLoad
      />
    </Block>
  )
}
